<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div style="display: flex;justify-content: flex-start;width: 100%;">
          <div class="btn" style="margin: 0;" @click="addUserModal('add')">
            + 添加权限组
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          border
          :header-cell-style="{
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="" align="center" label="权限组名称">
            <div slot-scope="scope">
              {{ scope.row }}
            </div>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            width="320"
          >
            <div slot-scope="scope" class="table-btn-box">
              <button
                size="mini"
                class="table-btn"
                @click="bindGroupModal(scope.row)"
              >
                关联账号
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleSettingModal(scope.row)"
              >
                权限设置
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="deleteGroup(scope.row)"
              >
                删除
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <!-- <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div> -->
    </div>
    <el-dialog :visible.sync="visible" class="dialog" width="480px" top="10vh">
      <div slot="title" class="dialog-title">
        添加权限组
      </div>
      <el-form
        ref="form"
        :model="form"
        class="user-form"
        label-width="auto"
        label-position="top"
      >
        <el-form-item
          label="权限组名称："
          prop="name"
          class="form-item"
          style="width: 100%;"
        >
          <el-input
            size="small"
            placeholder="请输入名称"
            style="width: 100%"
            v-model="form.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAdd">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visible2" class="dialog" width="640px" top="10vh">
      <div slot="title" class="dialog-title">
        关联账号
      </div>
      <div class="bind-box">
        <div class="left">
          <div class="title">组织架构</div>
          <el-tree
            :data="data"
            :props="defaultProps2"
            @node-click="handleNodeClick"
          >
          </el-tree>
        </div>
        <div class="right">
          <el-checkbox
            style="min-width: 120px;"
            v-model="item.selected"
            v-for="(item, index) in users"
            :key="index"
            @change="(e) => handleChange(e, item)"
            >{{ item.name }}</el-checkbox
          >
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible2 = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="bindGroup">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      size="480px"
      :with-header="false"
    >
      <div class="drawer-box">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: item.value === tabActive }"
            v-for="(item, index) in tabs"
            :key="index"
            @click="handleClickTab(item)"
          >
            {{ item.name }}
            <div class="bar"></div>
          </div>
        </div>
        <div class="drawer" v-if="tabActive === 0">
          <div class="search-box">
            <el-input
              placeholder="输入关键字进行过滤"
              size="small"
              class="input"
              v-model="filterText"
            >
            </el-input>
            <div class="btn" @click="handleSearch('menu')">确定</div>
          </div>
          <div class="tree">
            <el-tree
              class="filter-tree"
              :data="menuList"
              :props="defaultProps"
              :filter-node-method="filterNode"
              ref="treeMenu"
              show-checkbox
              @check="handleCheckChange"
              node-key="id"
              :default-checked-keys="checkedKeys"
            >
            </el-tree>
          </div>
        </div>
        <div class="drawer" v-if="tabActive === 1">
          <div class="search-box">
            <el-input
              placeholder="输入关键字进行过滤"
              size="small"
              class="input"
              v-model="filterText"
            >
            </el-input>
            <div class="btn" @click="handleSearch('api')">确定</div>
          </div>

          <div class="tree">
            <el-tree
              class="filter-tree"
              :data="apiList"
              :props="defaultProps"
              :filter-node-method="filterNode"
              ref="treeApi"
              show-checkbox
              @check="handleCheckChange"
              node-key="id"
              :default-checked-keys="checkedKeys"
            >
            </el-tree>
          </div>
        </div>
        <div class="btn" @click="handleConfirm('menu')" v-if="tabActive === 0">
          确定
        </div>
        <div class="btn" @click="handleConfirm('api')" v-if="tabActive === 1">
          确定
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'user-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '权限管理',
        secondTitle: '权限设置'
      },
      list: [],
      form: {

      },
      filter: {},
      visible: false,
      visible2: false,
      data: [],
      defaultProps: {
        children: 'sub',
        label: 'name'
      },
      defaultProps2: {
        children: 'list',
        label: 'name'
      },
      groupName: '',
      users: [],
      bindObj: {},
      drawerVisible: false,
      activeName: 'menu',
      filterText: '',
      menuList: [],
      apiList: [],
      checkedKeys: [],
      menuObj: {},
      tabs: [
        {
          name: '角色菜单',
          value: 0
        },
        {
          name: '角色api',
          value: 1
        }
      ],
      tabActive: 0,
      checkedObj: {},
      newCheckedObj: {},
      firstObj: {}
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 获取客户列表
    getList() {
      this.loading++;
      this.httpGet(this.$root.getGroupList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getOrgStructList(){
        this.loading++;
        this.httpGet(this.$root.getOrgStructList, {
          showUsers: 1,
          permission: this.groupName
        }).then(
            (res) => {
            this.loading--;
            this.data = res.list.map(item => {
              return {
                ...item,
                list: item.list.map(item2 => {
                  return {
                    ...item2,
                    list: item2.list.map(item3 => {
                      return {
                        ...item3,
                        list: null,
                        users: item3.list
                      }
                    })
                  }
                })
              }
            });
            console.log(this.data);
            },
            (res) => {
            this.loading--;
            this.$message.error(res);
            }
        );
    },
    handleNodeClick(data){
      this.users = [];
      if(data.type !== 3) return;
      this.users = data.users;
      // this.firstObj
      data.users.forEach(item => {
        if(!this.firstObj[item.id]) this.firstObj[item.id] = {...item};
      })
    },
    bindGroupModal(groupName){
      this.visible2 = true;
      this.users = [];
      this.bindObj = {};
      this.firstObj = {};
      this.groupName = groupName;
      this.getOrgStructList();
    },
    handleChange(e, data){
      this.bindObj[data.id] = {
        checked: e,
        name: data.name
      };
    },
    bindGroup(){
      let links = [],
      unlinks = [];
      for(let key in this.bindObj){
        if(this.firstObj[key].selected !== this.bindObj[key].checked){
          if(this.bindObj[key].checked){
            links.push({
              name: this.groupName,
              uid: +key
            })
          } else {
            unlinks.push({
              name: this.groupName,
              uid: +key
            })
          }
        }
      };
      this.loading++;
        this.httpPost(this.$root.bindGroup, {
          links,
          unlinks
        }).then(
        (res) => {
            this.loading--;
            this.visible2 = false;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getList();
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    },
    handleSettingModal(groupName){
      this.drawerVisible = true;
      this.tabActive = 0;
      this.groupName = groupName;
      this.getPermissionMenuList();
    },
    handleSetting(){

    },
    handleClickTab(val){
      this.checkedKeys = [];
      this.tabActive = val.value;
      this.filterText = '';
      if(val.value === 0) this.getPermissionMenuList();
      if(val.value === 1) this.getPermissionApiList();
    },
    handleSearch(type){
      // console.log(this.$refs.treeMenu, this.filterText);
      if(type === 'menu'){
        this.$refs.treeMenu.filter(this.filterText);
      } else if(type === 'api'){
        this.$refs.treeApi.filter(this.filterText);
      }
    },
    getPermissionMenuList(){
      // this.loading++;
        this.httpGet(this.$root.getPermissionMenuList, {
          group: this.groupName
        }).then(
        (res) => {
            // this.loading--;
            this.menuList = res.list.map(item => {
              return {
                ...item,
                ...item.first,
                isFirst: true
              }
            });
            let arr = [], obj = [];
            res.list.forEach(item => {
              let filter = item.sub.filter(item2 => {
                  if(item2.selected) {
                    obj = {...obj, [item2.id]: item2.name};
                    return item2.id
                  };
                });
              arr = [...arr, ...filter.map(item2 => {
                return item2.id
              })];
            });
            this.checkedKeys = arr;
            this.checkedObj = obj;
            // console.log(this.menuList);
            // console.log(this.checkedKeys, this.checkedObj );
        },
        (res) => {
            // this.loading--;
            this.$message.error(res);
        }
        );
    },
    handleCheckChange(data, checked) {
      console.log(data, checked);
      if(data.isFirst){
        data.selected = !data.selected;
        data.sub.forEach(item => {
          item.selected = data.selected;
        })
      } else {
        data.selected = !data.selected;
      }
      // console.log(checked);
      let obj = {};
      checked.checkedNodes.forEach(item => {
        if(item.isFirst){
          if(item.selected){
            item.sub.forEach(item2 => {
              obj[item2.id] = item2.name;
            });
          }
        } else {
          item.selected && (obj[item.id] = item.name);
        }
      });
      console.log(obj);
      this.newCheckedObj = obj;
      // if(data.isFirst) return;
      // if(data.isFirst){
      //   data.sub.forEach(item => {
      //     this.menuObj[item.id] = {
      //       checked,
      //       name: item.name
      //     };
      //   })
      // } else {
      //   this.menuObj[data.id] = {
      //     checked,
      //     name: data.name
      //   };
      // }
    },

    getPermissionApiList(){
      // this.loading++;
      this.httpGet(this.$root.getPermissionApiList, {
          group: this.groupName
        }).then(
        (res) => {
            // this.loading--;
            this.apiList = res.list.map(item => {
              return {
                ...item,
                isFirst: true
              }
            });
            let arr = [], obj = [];
            res.list.forEach(item => {
              let filter = item.sub.filter(item2 => {
                  if(item2.selected) {
                    obj = {...obj, [item2.id]: item2.name};
                    return item2.id
                  };
                });
              arr = [...arr, ...filter.map(item2 => {
                return item2.id
              })];
            });
            this.checkedKeys = arr;
            this.checkedObj = obj;
        },
        (res) => {
            // this.loading--;
            this.$message.error(res);
        }
        );
    },




    handleConfirm(type){
      console.log(this.checkedObj, this.newCheckedObj, 123);
      let add = [], remove = [];
      for(let key in this.newCheckedObj){
        if(!this.checkedObj[key]){
          add.push({
            id: +key,
            name: this.newCheckedObj[key]
          });
        }
      }
      for(let key in this.checkedObj){
        if(!this.newCheckedObj[key]){
          remove.push({
            id: +key,
            name: this.checkedObj[key]
          });
        }
      }
      console.log(add, remove);
      // this.loading++;
      let url = '';
      if(type === 'menu'){
        url = 'updatePermissionMenu';
      } else if(type === 'api'){
        url = 'updatePermissionApi';
      }
      this.httpPost(this.$root[url], {
        add,
        remove,
        group: this.groupName
      }).then(
      (res) => {
          // this.loading--;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          if(type === 'menu'){
            this.getPermissionMenuList();
          } else if(type === 'api'){
            this.getPermissionApiList();
          }
      },
      (res) => {
          // this.loading--;
          this.$message.error(res);
      }
      );
    },







    addUserModal(type, rowData = {}) {
      this.type = type;
      this.form = {
        partnerName: "",
        partnerPhone: "",
        weChat: "",
        qq: "",
        company: "",
        position: "",
        account: "",
        bank: "",
        bankNo: ""
      };
      if(type === 'edit'){
        let form = {...this.form};
        for(let key in form){
          form[key] = rowData[key];
        };
        this.form = form;
        this.form.id = rowData.id;
      }
      this.$refs.form && this.$refs.form.clearValidate();
      this.visible = true;
    },
    // 身份授权
    handleAdd() {
        this.loading++;
        this.httpPost(this.$root.addGroup, this.form).then(
        (res) => {
            this.loading--;
            this.visible = false;
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getList();
        },
        (res) => {
            this.loading--;
            this.$message.error(res);
        }
        );
    },
    deleteGroup(name){
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该权限组吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteGroup, {
          name
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.visible3 = false;
            this.loading--;
            this.getList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
.struct-select .el-cascader-panel li[aria-haspopup] .el-checkbox{
    display: none !important;
}
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';
>>>.el-form-item__label{
  padding: 0;
  height: 30px;
}
>>>.el-cascader-panel{
    background: red
}
.el-form-item{
  margin: 0;
}
.page-box {

  .container {
    padding: 24px;
    .filter-box{
      .filter-item {
        margin-right: 28px;
        .select, .input {
          width: 180px;
        }

        .date-input {
          width: 380px;
        }
      }

      .btn-box {
        margin: 0;
      }
    }
    .content {

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      .import-btn{
        background: #E67E4E;
        color: #fff;
        border-color: #E67E4E;
        padding: 0 12px;
        width: auto;
        margin: 0;
        margin-left: 12px;
      }

      // // 表格按钮
      // .table-btn {
      //   // width: 65px;
      //   height: 24px;
      //   line-height: 24px;
      //   color: gray3;
      //   font-size: 12px;
      //   margin-right: 8px;
      //   cancel-btn();
      //   padding: 0 8px;
      // }

      .table {
        margin-top: 16px !important;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .dialog-title{
    // height: 56px;
    // background: #FAFAFA;
  }
  .bind-box{
    width: 100%;
    flex-x(flex-start, flex-start);
    .left{
      width: 240px;
      .title{
        word(20px, #333);
        font-weight: bold;
        margin: 10px 0 12px;
      }
    }
    .right{
      height: 100%;
      padding-top: 12px;
      flex: 1;
    }
  }
  .drawer-box{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    flex-y(flex-start);
    // overflow-y: auto;
    // overflow-x: hidden;

    .tabs{
      width: 100%;
      height: 56px;
      background: #FAFAFA;
      flex-x(flex-start);
      padding: 0 10px;
      box-sizing: border-box;

      .tab{
        width: auto;
        margin: 0 18px;
        background: #FAFAFA;
        word(18px, #999);
        height: 56px;
        line-height: 56px;
        cursor: pointer;
        &.active{
          color: btn-color;
          position: relative;
          .bar{
            width: 30px;
            height: 3px;
            background: btn-color;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
          }
        }
      }
    }
    .btn {
      width: 66px;
      height: 32px;
      line-height: 32px;
      confirm-btn();
      font-size: 14px;
      margin: 16px 0;
    }
    .drawer{
      width: 100%;
      flex: 1;
      flex-y(flex-start, flex-start);
      overflow: hidden;
      .search-box{
        width: 100%;
        padding: 0 18px;
        box-sizing: border-box;
        flex-x();
        .input{
          width: 360px;
        }
      }
      .tree{
        width: 100%;
        overflow-y: auto;
      }
    }
  }
  .filter-tree{
    margin-left: 18px;
    margin-top: 8px;
  }
}
</style>
